import ApiClient from './ApiClient';

class ticketApi extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  appendTicketFilterParams(url, {
    status,
    agent_ids,
    start_date,
    end_date,
    priority,
    q,
    date_field,
    label_ids,
  }) {
    if (status && status.length > 0) {
      const statusArray = Array.isArray(status) ? status : [status];
      statusArray.forEach(s => { url += `&status[]=${encodeURIComponent(s)}`; });
    }
    if (agent_ids && agent_ids.length > 0) {
      agent_ids.forEach(id => { url += `&agent_ids[]=${encodeURIComponent(id)}`; });
    }
    if (start_date) url += `&start_date=${encodeURIComponent(start_date)}`;
    if (end_date) url += `&end_date=${encodeURIComponent(end_date)}`;
    if (priority && priority.length > 0) {
      priority.forEach(p => { url += `&priority[]=${encodeURIComponent(p)}`; });
    }
    if (q) url += `&q=${encodeURIComponent(q)}`;
    if (date_field) url += `&date_field=${encodeURIComponent(date_field)}`;
    if (label_ids && label_ids.length > 0) {
      label_ids.forEach(id => { url += `&label_ids[]=${encodeURIComponent(id)}`; });
    }
    return url;
  }

  async getTickets({
    kanbanfunnel_id,
    page = 1,
    per_page = 10,
    status = ['open'],
    agent_ids = null,
    start_date = null,
    end_date = null,
    priority = null,
    q = null,
    date_field = null,
    label_ids = null,
  }) {
    let url = `${this.url}tickets?kanbanfunnel_id=${kanbanfunnel_id}&page=${page}&per_page=${per_page}`;
    url = this.appendTicketFilterParams(url, {
      status,
      agent_ids,
      start_date,
      end_date,
      priority,
      q,
      date_field,
      label_ids,
    });
    return await axios.get(url);
  }

  async getTicketsByColumns({
    kanbanfunnel_id,
    columns_id,
    page = 1,
    per_page = 10,
    status,
    agent_ids,
    start_date,
    end_date,
    priority,
    q,
    date_field,
    label_ids,
  }) {
    let url = `${this.url}tickets/by_column?kanbanfunnel_id=${kanbanfunnel_id}&columns_id=${columns_id}&page=${page}&per_page=${per_page}`;
    url = this.appendTicketFilterParams(url, {
      status,
      agent_ids,
      start_date,
      end_date,
      priority,
      q,
      date_field,
      label_ids,
    });
    return await axios.get(url);
  }

  async getTicketsByContact(contact_id) {
    return await axios.get(`${this.url}tickets/by_contact/${contact_id}`);
  }

  async getTicket(id) {
    return await axios.get(`${this.url}tickets/${id}`);
  }

  async createTicket(payload) {
    return await axios.post(`${this.url}tickets`, payload);
  }

  async updateTicket(id, payload) {
    return await axios.put(`${this.url}tickets/${id}`, payload);
  }

  async bulkUpdateTicketColumns(payload) {
    return await axios.patch(`${this.url}tickets/bulk_update_stage`, payload);
  }

  async bulkUpdateTicketLabels(payload) {
    return await axios.patch(`${this.url}tickets/bulk_update_labels`, payload);
  }

  async bulkUpdateContactAttributes(payload) {
    return await axios.patch(
      `${this.url}tickets/bulk_update_contact_attributes`,
      payload
    );
  }

  async deleteTicket(id) {
    return await axios.delete(`${this.url}tickets/${id}`);
  }

  async getDashboardMetrics(queryParams = {}) {
    const queryString = Object.keys(queryParams).length > 0 ? `?${new URLSearchParams(queryParams).toString()}` : '';
    return await axios.get(`${this.url}tickets/dashboard_metrics${queryString}`);
  }

  async sendCommunication(id, payload) {
    return await axios.post(`${this.url}tickets/${id}/communications`, { communication: payload });
  }

  async getContacts(id) {
    return await axios.get(`${this.url}tickets/${id}/contacts`);
  }

  async addContact(id, contactId) {
    return await axios.post(`${this.url}tickets/${id}/contacts`, {
      ticket_contact: { contact_id: contactId },
    });
  }

  async removeContact(id, contactId) {
    return await axios.delete(`${this.url}tickets/${id}/contacts/${contactId}`);
  }

  async getContacts(id) {
    return await axios.get(`${this.url}tickets/${id}/contacts`);
  }

  async addContact(id, contactId) {
    return await axios.post(`${this.url}tickets/${id}/contacts`, {
      ticket_contact: { contact_id: contactId },
    });
  }

  async removeContact(id, contactId) {
    return await axios.delete(`${this.url}tickets/${id}/contacts/${contactId}`);
  }

}

export default new ticketApi();
